module.exports = __webpack_public_path__ + "img/logo_blanco_tag.874e0f07.png";